import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import {
  isAdminLoginVisibleSelector,
  isLoginVisibleSelector,
  isRegisterVisibleSelector
} from "@client/widgets/Header/selectors";
import { isStaffOrSuperUser } from "@common/appInfo";
import Component, { type HeaderLoginProps, INVISIBLE_PROPS } from "./component";

const mapStateToProps = (state: AppState): HeaderLoginProps & WithIsVisibleHOCProps => {
  const isAdminLoginVisible = isAdminLoginVisibleSelector(state) && !isStaffOrSuperUser();
  const isLoginVisible = isLoginVisibleSelector(state);
  const isUserVisible = isRegisterVisibleSelector(state);
  if (!isUserVisible && !isLoginVisible && !isAdminLoginVisible) return INVISIBLE_PROPS;

  return {
    isAdminLoginVisible,
    isLoginVisible,
    isUserVisible,
    isVisible: true
  };
};

export default connectCustom(mapStateToProps)(Component);
